import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import { AuthProvider } from './context/AuthContext';
import { CajaProvider } from './context/CajaContext';

const root = createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <AuthProvider>
      <CajaProvider>
        <App />
      </CajaProvider>
    </AuthProvider>
  </React.StrictMode>
);
